import React from "react";
import { MsalProvider } from "@azure/msal-react";
import { IPublicClientApplication } from "@azure/msal-browser";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { NoMatch } from "./pages/NoMatch";
import { PageLayout } from "./pages/layout";
import { Home } from "./pages/Home";
import { Event } from "./pages/Event";

const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			staleTime: 1000 * 60 * 60, // 1 hour
			refetchOnWindowFocus: false,
		},
	},
});

const App: React.FC<{ msalInstance: IPublicClientApplication }> = ({ msalInstance }) => {
	return (
		<React.StrictMode>
			<QueryClientProvider client={queryClient}>
				<MsalProvider instance={msalInstance}>
					<BrowserRouter>
						<Routes>
							<Route path="/" element={<PageLayout />}>
								<Route
									index
									element={<Navigate to="/home" replace={true} />}
								/>
								<Route path="home" element={<Home />} />
								<Route path="event/:id" element={<Event />} />
								<Route path="*" element={<NoMatch />} />
							</Route>
						</Routes>
					</BrowserRouter>
				</MsalProvider>
			</QueryClientProvider>
		</React.StrictMode>
	);
}

export default App;
